import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import styles from "./SignIn.module.css";
import Logo from "../../Assets/Images/readPro_logo.png";
import RefreshCaptchIMg from "../../Assets/Images/refresh_captcha_image.svg"
import background from "../../Assets/Images/background.svg";
import TextInput from "../../Components/TextInput/TextInput";
import SignInTextInput from "../../Components/SignInTextInput/SignInTextInput";
import PasswordInput from "../../Components/Password/PasswordInput";
import { MdEmail } from "react-icons/md";
import { RiLockPasswordFill } from "react-icons/ri";
import { signInFirebase, signInMongo ,signInMongoMB,createCaptcha, createCaptchaV2} from "../../Services/auth";
import { emailValidate, passwordValidate } from "../../Values/validatorsnew";
import { useDispatch } from "react-redux";
import Loading from "../../Components/Loading/Loading";
import Logo2 from "../../Assets/Images/ify_logo2.png";
// import LogoNew from "../../Assets/Images/ify_logo_new.png";
import LogoNew from "../../Assets/Images/IFY_Magicbricks_Logo.png";
import LogoOld from "../../Assets/Images/head.svg";
import Cookies from "universal-cookie";
import LatestBackground from "../../Assets/Images/signin_background_latest.svg";
import AppStore from "../../Assets/Images/appstore.svg";
import PlayStore from "../../Assets/Images/playstore.svg";
import { googleAnalytics } from "../../Services/users";

type props = {
  history: any;
};

const SignIn: FunctionComponent<props> = ({ history }) => {
  const emailRef: any = useRef();
  const passwordRef: any = useRef();
  const dispatcher = useDispatch();
  const [load, setLoad] = useState(false);
  const [userProfileUid, setUserProfileUid] = useState<any>();
  const cookies = new Cookies();
  cookies.set("uId", userProfileUid);
  const changeLoad = (value: boolean) => {
    setLoad(value);
  };

  const [captchaInput, setCaptchaInput] = useState<string>("");
  const[answer,setAnswer]=useState<string>("");
  const [captchaImageUrl, setCaptchaImageUrl] = useState<string>(""); 
  const [showForget, setShowForget] = useState(false);
  const forgetRef: any= useRef();
  const [captchaError, setcaptchaError] = useState<string>(""); 

  const genereteCaptcha = ()=> {
    createCaptchaV2(
      (value)=>{setCaptchaImageUrl(value)},
      (value)=>{setAnswer(value)},
      dispatcher
    );
  }

  const showHideForgot = (event:any) => {
    if (forgetRef.current.contains(event.target)) {
        return;
    }
    setShowForget(false);
  };

  useEffect(()=>{
    genereteCaptcha();

    document.body.addEventListener("click", showHideForgot, { capture: true });
    return () => {
        document.body.removeEventListener("click", showHideForgot, { capture: true });
    };
  },[])

  const redirectToMbLogin = ()=> {
    setShowForget(false);
    window.open("https://accounts.magicbricks.com/userauth/login", "_blank");
  }

  const login = async (email: string, password: string) => {
    // signInFirebase(
    //   email,
    //   password,
    //   history,
    //   dispatcher,
    //   changeLoad,
    //   setUserProfileUid
    // );
    signInMongo(
      email,
      password,
      history,
      dispatcher,
      changeLoad,
      setUserProfileUid,
      answer,
      captchaInput,
      (value)=>{setCaptchaInput(value)},
      (value)=>{setCaptchaImageUrl(value)},
      (value)=>{setAnswer(value)}
    );

    // genereteCaptcha()
  };

  const loginMB = async (email: string, password: string) => {
    // signInFirebase(
    //   email,
    //   password,
    //   history,
    //   dispatcher,
    //   changeLoad,
    //   setUserProfileUid
    // );
    signInMongoMB(
      email,
      password,
      history,
      dispatcher,
      changeLoad,
      setUserProfileUid,
      answer,
      captchaInput,
      (value)=>{setCaptchaInput(value)},
      (value)=>{setCaptchaImageUrl(value)},
      (value)=>{setAnswer(value)},
    );

    // genereteCaptcha()
  };

  const handleCaptchaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    // Allow numbers between 1 and 9, and the '-' symbol
    if (/^-?[0-9]*$/.test(value)) {
        setCaptchaInput(value);  // Update state with valid input
    }
};
  useEffect(()=>{
    googleAnalytics('SignIn_Screen')
  },[])
  return (
    <div
      className={styles.container}
    >
      <img
        src={LogoNew}
        alt="logo"
        className={styles.logo} />
      <div style={{ display: "flex", height: "80vh" }}>
        <div className={styles.box1}>
          <img
            src={LatestBackground}
            alt=""
            width="100%"
            height="100%"
          />
        </div>
        <div className={styles.box2}>
          <div className={styles.form}>
            <div className={styles.header}>
              <h4 style={{ fontFamily: "Poppins", fontWeight: 600, fontSize: "24px" }}>Welcome</h4>
              <p className={styles.headerText} style={{ fontSize: "14px" }}>Sign in to continue</p>
            </div>
            <div className={styles.inputs}>
              <SignInTextInput title={"Email"} ref={emailRef} validator={emailValidate}>
                <MdEmail color={"#053535"} />
              </SignInTextInput>
              <div className={styles.loginViaMobile} onClick={ ()=>{history.replace("/signInOtp")}}>or Sign in Via Mobile</div>
              <PasswordInput
                title={"Password"}
                ref={passwordRef}
                validator={passwordValidate}
                onPress={() =>
                  login(emailRef.current?.value, passwordRef.current?.value)
                }
              >
                <RiLockPasswordFill color={"#053535"} />
              </PasswordInput>
              
              <div className={styles.loginViaMobile} ref={forgetRef} onClick={()=>setShowForget(true)}>
                Forgot Password?
                
                {showForget && 
                  <div className={styles.forgotTooltip}>
                    <div className={styles.forgotTooltipTitle}>Reset password for</div>
                    <div className={styles.forgotTooltipButton} onClick={redirectToMbLogin}>Magicbricks</div>
                    <div className={`${styles.forgotTooltipButton} ${styles.readPro}`} onClick={() => history.push("/forgetpassword")}>Read Pro</div>
                  </div>
                }
              </div>
              
              <div className={styles.captcha}>
                <img src={captchaImageUrl} className={styles.captchaImg} alt="Captch" />
                <div className={styles.captchaRefresh} onClick={genereteCaptcha}>
                  <div><img src={RefreshCaptchIMg} alt="refresh" /></div>
                  Refresh
                </div>
                
                <div>
                  <input
                    className={styles.captchaInput}
                    type="text"
                    placeholder="Enter CAPTCHA"
                    value={captchaInput}
                    onChange={handleCaptchaChange}
                    style={{textAlign:"center",fontSize:"30"}}
                  />
                </div>
              </div>

            </div>

            <div className={styles.buttons}>
              <button
                className={styles.button}
                onClick={() =>
                  login(emailRef.current?.value.trim(), passwordRef.current?.value)
                }
              >
                Sign In with ReadPro
              </button>


              <button
                className={styles.mbButton}
                onClick={() =>
                  loginMB(emailRef.current?.value.trim(), passwordRef.current?.value)
                }
              >
                Sign in with <span>magicbricks</span>
              </button>
              
              {/* <div
                className={styles.loginViaOtp}
                onClick={ ()=>{history.replace("/")}}
              >
                <p>Login Via Mobile</p>
              </div> */}
              
              {/* <div
                className={styles.forgetPassword}
                onClick={() => history.push("/forgetpassword")}
              >
                <p style={{ marginBottom: "20px", marginTop: "10px", fontSize: "14px", color: "black" }}>Forgot Password?</p>
              </div> */}
            </div>

            <div className={styles.downloadApptext}>Download our app</div>
            
            <div className={styles.storeIcons}>
              <div className={styles.iconContainer1}>
                <a href="https://play.google.com/store/apps/details?id=com.readpro" target="_blank">
                  <img
                    src={PlayStore}
                    alt={"logo"}
                    width={"25px"}
                  />
                </a>
              </div>
              <div className={styles.iconContainer2}>
                <a href="https://apps.apple.com/in/app/read-pro/id1566457452" target="_blank">
                  <img
                    src={AppStore}
                    alt={"logo"}
                    width={"40px"}
                  />
                </a>
              </div>
            </div>
            {/* <p style={{ textAlign: "center", marginTop: "24px", fontSize: "14px" }}>Powered by</p>
            <div className={styles.socialIcons}>
              <img
                src={Logo2}
                alt={"logo"}
                height={"35px"}
              />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
